export default __webpack_public_path__ + "static/2-ed4f22c3623fcab1cb734dc03d7029b4.png";